import React, { useState, useEffect } from "react";
import PublishButton from "./ChatPublishFeature/PublishButton";
import getExtension from "../../../utils/ExtensionHandlingUtils/getExtension";
import useUserDetails from "../../../utils/auth/UserDetails";
import { Select, MenuItem, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, Box, Divider, Chip, Typography, Avatar } from "@mui/material";
import { ExpandMore, Close, Info } from "@mui/icons-material";
import "./ChatWindowHeader.css";
import ExtensionIcon from '@mui/icons-material/Extension';
import { Button } from "primereact/button";
const ChatWindowHeader = ({
  chatObject,
  onExtensionFetched,
  selectedModel,
  setSelectedModel,
  models,
  setModels, onGeneratePDF,

}) => {
  const [extensionDetails, setExtensionDetails] = useState(null);
  const [isLoadingExtension, setIsLoadingExtension] = useState(false);
  const [showDetailsDialog, setShowDetailsDialog] = useState(false);
  const userDetails = useUserDetails();

  const extensionId = chatObject?.extensionId || "DONA";
  const isDona = extensionId === "DONA";

  useEffect(() => {
    if (!chatObject?.chatId || !userDetails?.userId) return;
    setIsLoadingExtension(true);

    const fetchExtension = async (extId) => {
      try {
        return await getExtension(userDetails.userId, extId);
      } catch (error) {
        console.error("Error fetching extension:", error);
        return null;
      }
    };

    (async () => {
      let data = await fetchExtension(extensionId);
      if (!data && !isDona) data = await fetchExtension("DONA");
      setExtensionDetails(data || null);
      if (data?.models) setModels(data.models);
      onExtensionFetched?.(data);
      setIsLoadingExtension(false);
    })();
  }, [chatObject, userDetails]);

  return (
    <div className="chat-window-header">
      <div className="header-extension-name">
        <span
          onClick={() => setShowDetailsDialog(true)}
          role="button"
          className={`extension-name ${isLoadingExtension ? "loading" : ""}`}
        >
          {isLoadingExtension ? "Loading..." : extensionDetails?.extensionName || "DoAssist"}
        </span>

        <Select
          value={selectedModel}
          onChange={(e) => setSelectedModel(e.target.value)}
          IconComponent={ExpandMore}
          sx={{
            border: "none",
            boxShadow: "none",
            ".MuiOutlinedInput-notchedOutline": { border: 0 },
            "&:hover .MuiOutlinedInput-notchedOutline": { border: 0 },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": { border: 0 },
            fontSize: "inherit",
          }}
          displayEmpty
        >
          {models.map((model) => (
            <MenuItem key={model} value={model} disabled={["Deepseek-R1", "o1"].includes(model)}>
              {model}
            </MenuItem>
          ))}
        </Select>
      </div>

      <div className="header-icons">
        <Button
          label="Download"
          icon="pi pi-download"
          className="p-button-outlined "
          onClick={onGeneratePDF}
        />


        <PublishButton chatObject={chatObject} />
        <IconButton onClick={() => setShowDetailsDialog(true)} sx={{ color: "#99cc33" }}>
          <Info fontSize="small" />
        </IconButton>
      </div>

      {/* Extension Details Dialog with Improved Styling */}
      {/* Extension Details Dialog with Purple Styling */}
      <Dialog
        open={showDetailsDialog}
        onClose={() => setShowDetailsDialog(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 1,
            px: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar
              src={extensionDetails?.imagePath || undefined}
              sx={{
                width: 64,
                height: 64,
                border: '2px solid',
              }}
            >
              {!extensionDetails?.imagePath && <ExtensionIcon />}

            </Avatar>
            <Box>
              <Typography
                variant="h3"
                fontWeight={700}
                sx={{
                  color: '#333366',
                  lineHeight: 1.2,
                  mb: 0.5
                }}
              >
                {extensionDetails?.extensionName || "Unknown Extension"}
              </Typography>
              {(extensionDetails?.userName || isDona) && (
                <Typography
                  color="text.secondary"
                  variant="body2"
                  sx={{ fontStyle: 'italic' }}
                >
                  Created by <strong>{isDona ? "Admin" : extensionDetails?.userName || "Unknown Author"}</strong>
                </Typography>
              )}
            </Box>
          </Box>
          <IconButton
            onClick={() => setShowDetailsDialog(false)}
            size="small"
            sx={{
              color: 'purple',
              '&:hover': {
                backgroundColor: 'rgba(128, 0, 128, 0.1)',
                color: 'darkviolet'
              }
            }}
          >
            <Close fontSize="small" />
          </IconButton>
        </DialogTitle>

        <Divider light />

        <DialogContent sx={{ p: 3, pt: 2 }}>
          {[
            { label: "Description", value: extensionDetails?.extensionDescription },
            { label: "Instructions", value: extensionDetails?.extensionInstructions }
          ].map((item, index) => (
            <Box key={index} sx={{ mb: 2 }}>
              <Typography
                variant="subtitle1"
                fontWeight={600}
                sx={{
                  color: '#333366',
                  mb: 1
                }}
              >
                {item.label}
              </Typography>
              <Typography
                variant="body1"
                color="text.secondary"
                sx={{
                  p: 1.5,
                  border: '1px solid rgba(128, 0, 128, 0.1)'
                }}
              >
                {item.value || "No information available."}
              </Typography>
            </Box>
          ))}

          <Box sx={{ mt: 2 }}>
            <Typography
              variant="subtitle1"
              fontWeight={600}
              sx={{
                color: 'purple',
                mb: 1
              }}
            >
              Tools
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {extensionDetails?.tools?.length ? (
                extensionDetails.tools.map((tool, index) => (
                  <Chip
                    key={index}
                    label={tool}
                    variant="outlined"
                    sx={{
                      color: '#333366',

                    }}
                  />
                ))
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No tools listed.
                </Typography>
              )}
            </Box>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ChatWindowHeader;